webpackJsonp([26379419371658],{

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(9);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _widgetContainer = __webpack_require__(21);
	
	var _widgetContainer2 = _interopRequireDefault(_widgetContainer);
	
	var _categoryTag = __webpack_require__(95);
	
	var _categoryTag2 = _interopRequireDefault(_categoryTag);
	
	var _postInfo = __webpack_require__(96);
	
	var _postInfo2 = _interopRequireDefault(_postInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return Glamor.createElement(
	    "div",
	    null,
	    props.title ? Glamor.createElement(
	      "h1",
	      { style: { marginTop: "" + (0, _typography.rhythm)(1 / 2) } },
	      props.title
	    ) : null,
	    props.group.map(function (_ref, index) {
	      var node = _ref.node;
	      return Glamor.createElement(
	        _widgetContainer2.default,
	        { key: index },
	        Glamor.createElement(
	          "h2",
	          {
	            style: {
	              marginBottom: "" + (0, _typography.rhythm)(1 / 4),
	              marginTop: "" + (0, _typography.rhythm)(1 / 4)
	            }
	          },
	          Glamor.createElement(
	            _gatsbyLink2.default,
	            { to: node.fields.slug },
	            node.frontmatter.title
	          )
	        ),
	        Glamor.createElement(_postInfo2.default, {
	          date: node.frontmatter.date,
	          timeToRead: node.timeToRead
	        }),
	        Glamor.createElement(
	          "p",
	          {
	            style: {
	              display: "flex",
	              marginTop: "" + (0, _typography.rhythm)(1 / 2),
	              paddingTop: "" + (0, _typography.rhythm)(1 / 2),
	              borderTop: "1px solid hsla(0,0%,0%,0.07)"
	            }
	          },
	          node.excerpt
	        ),
	        Glamor.createElement(
	          _gatsbyLink2.default,
	          { to: node.fields.slug },
	          "\u0110\u1ECDc th\xEAm"
	        ),
	        Glamor.createElement(_categoryTag2.default, { node: node })
	      );
	    })
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _typography = __webpack_require__(9);
	
	var _widgetContainer = __webpack_require__(21);
	
	var _widgetContainer2 = _interopRequireDefault(_widgetContainer);
	
	__webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavPageLink = function NavPageLink(props) {
	  var url = props.url,
	      test = props.test,
	      children = props.children;
	
	
	  return Glamor.createElement(
	    "div",
	    null,
	    test ? Glamor.createElement(
	      "span",
	      null,
	      children
	    ) : Glamor.createElement(
	      _gatsbyLink2.default,
	      { to: url },
	      children
	    )
	  );
	};
	
	exports.default = function (props) {
	  var index = props.index,
	      pageCount = props.pageCount,
	      pathPrefix = props.pathPrefix;
	
	  var fixPrefix = "/" + (pathPrefix ? pathPrefix + "/" : "");
	  var previousUrl = fixPrefix + (index - 1 == 1 ? "" : (index - 1).toString() + "/");
	  var nextUrl = fixPrefix + ((index + 1).toString() + "/");
	  var first = index === 1;
	  var last = index === pageCount;
	
	  // Create array respresense for each page as
	  // value: 1 0 currentIndex 0 pageCount
	  // display: 1 ... currentIndex ... pageCount 
	  var arr = [];
	  for (var i = 1; i <= pageCount; i++) {
	    if (i === 1 || i === pageCount || i >= index - 2 && i <= index + 2) arr.push(i);else if (arr[arr.length - 1] !== 0) arr.push(0);
	  }
	
	  return Glamor.createElement(
	    _widgetContainer2.default,
	    null,
	    Glamor.createElement(
	      "div",
	      {
	        style: {
	          display: "flex",
	          justifyContent: "space-between"
	        }
	      },
	      Glamor.createElement(
	        NavPageLink,
	        { test: first, url: previousUrl },
	        Glamor.createElement("i", { className: "fa fa-angle-double-left" }),
	        " ",
	        "Quay lại"
	      ),
	      Glamor.createElement(
	        "div",
	        null,
	        arr.map(function (value, idx) {
	          return value == 0 ? Glamor.createElement(
	            "span",
	            { key: idx },
	            "..."
	          ) : value == index ? Glamor.createElement(
	            "span",
	            {
	              key: idx,
	              style: { margin: "" + (0, _typography.rhythm)(1 / 4), color: "#dd4b39" }
	            },
	            value
	          ) : Glamor.createElement(
	            _gatsbyLink2.default,
	            {
	              key: idx,
	              to: fixPrefix + (value == 1 ? "" : value + "/"),
	              style: { margin: "" + (0, _typography.rhythm)(1 / 4) }
	            },
	            value
	          );
	        })
	      ),
	      Glamor.createElement(
	        NavPageLink,
	        { test: last, url: nextUrl },
	        "Tiếp theo",
	        " ",
	        Glamor.createElement("i", { className: "fa fa-angle-double-right" })
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(9);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _articleList = __webpack_require__(66);
	
	var _articleList2 = _interopRequireDefault(_articleList);
	
	var _widgetNavpage = __webpack_require__(67);
	
	var _widgetNavpage2 = _interopRequireDefault(_widgetNavpage);
	
	var _functions = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var pathContext = _ref.pathContext,
	      data = _ref.data;
	  var group = pathContext.group,
	      index = pathContext.index,
	      pageCount = pathContext.pageCount,
	      additionalContext = pathContext.additionalContext,
	      pathPrefix = pathContext.pathPrefix;
	  var category = additionalContext.category;
	
	  var categoryTitle = "Chuy\xEAn m\u1EE5c " + (category.charAt(0).toLowerCase() + category.slice(1));
	
	  return Glamor.createElement(
	    "div",
	    { style: { marginTop: "" + (0, _typography.rhythm)(1 / 2) } },
	    Glamor.createElement(_reactHelmet2.default, {
	      title: categoryTitle + " - " + data.site.siteMetadata.title,
	      meta: [{ name: 'description', content: "" + data.site.siteMetadata.description }, { name: 'keywords', content: "" + data.site.siteMetadata.keywords }].concat((0, _functions.getRobotIndexTag)(index))
	    }),
	    Glamor.createElement(_articleList2.default, {
	      title: categoryTitle,
	      group: group
	    }),
	    Glamor.createElement(_widgetNavpage2.default, {
	      index: index,
	      pageCount: pageCount,
	      pathPrefix: pathPrefix
	    })
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getRobotIndexTag = getRobotIndexTag;
	function getRobotIndexTag(index) {
	  return index > 1 ? [{ name: "robots", content: "noindex" }, { name: "googlebot", content: "noindex" }] : [];
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-categories-js-8b11c50fd4e60226e18b.js